import type { FC } from 'react'
import type { MenuItemType } from '../../frontend-types'
import { IconCircle } from '../atoms/IconCircle'
import { MenuItemLink } from '../atoms/MenuItemLink'
import { MenuLink } from '../atoms/MenuLink'

export type MegaMenuItemProps = {
	megamenuItem: MenuItemType | null
}

export const MegaMenuItem: FC<MegaMenuItemProps> = ({ megamenuItem }) => {
	const { title, description, href, target, children } = megamenuItem || {}

	return (
		<ul className="pr-xl pb-3xl">
			<li>
				<MenuItemLink href={href} target={target} className="group">
					<span className="flex items-start justify-between">
						<span className="flex flex-col gap-y-xl tablet-l:gap-y-lg">
							{title && <span className="text-h3">{title}</span>}
							{description && (
								<span className="mr-7.5 text-body-xs text-blue-tint-10">{description}</span>
							)}
						</span>
						<IconCircle
							icon={['fas', 'chevron-right']}
							size="sm"
							theme="blue"
							className="tablet-l:mt-0.5 desktop:mt-1"
						/>
					</span>
				</MenuItemLink>
				<ul className="mt-3xl flex flex-col gap-y-md tablet-l:mt-xl">
					{children?.map((item) => (
						<MenuLink key={item.title} menuItem={item} />
					))}
				</ul>
			</li>
		</ul>
	)
}
